import React from "react";
import './skill_item.css';
const SkillItem = ({img}) =>{
    return(
        <>
         <img src={img} alt= "skills_icons"/>
        </>
    );
}

export default SkillItem;